<template>
  <div class="loader_wrap">
    <div class="loader_inner">
      <div class="loader_ring">
        <div
          class="loader_ring-inner"
          :style="
            'border-color: ' +
            user.config.parameters.parameters.colorprimary +
            ' transparent ' +
            user.config.parameters.parameters.colorprimary +
            ' transparent;'
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: userGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'Loader',
  computed: {
    ...userGetters(['user'])
  }
});
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  z-index: 1260;
  height: 50px;
  width: 50px;
  overflow: visible;
  margin: auto;
  top: 50%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
}

.loader_inner {
  position: absolute;
  z-index: 1250;
  height: 120px;
  width: 120px;
  overflow: visible;
  margin: auto;
  top: 50%;
  left: 50%;
  border-radius: 4rem;
  margin-top: -60px;
  margin-left: -60px;
  background-color: rgb(255, 255, 255, 80%); // dette er en fejl, skal være rgba
  box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.35);
}

.loader_wrap {
  position: fixed;
  z-index: 1200;
  margin: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(147, 147, 147, 50%);  // dette er en fejl, skal være rgba
  cursor: wait;
}

.loader_ring {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
}
.loader_ring-inner {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 72px;
  height: 72px;
  margin-top: -36px;
  margin-left: -36px;
  border-radius: 50%;
  border: 6px solid transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
